import { Volume2, VolumeX } from 'lucide-react';
import { Slider } from '@/components/ui/slider';

/**
 * Compact vertical volume control for timeline clip bars (video embedded audio or audio lane).
 */
export function TimelineClipVerticalVolume({
  volume = 0.8,
  muted = false,
  onVolumeChange,
  onMuteToggle,
  accent = '#ffffff',
  testId,
}) {
  const pct = muted ? 0 : Math.round(Math.min(100, Math.max(0, Number(volume) * 100)) || 0);

  return (
    <div
      className="flex flex-col items-center justify-center gap-0.5 shrink-0 py-0.5 px-0.5 pointer-events-auto"
      onMouseDown={(e) => e.stopPropagation()}
      onClick={(e) => e.stopPropagation()}
      data-testid={testId}
    >
      {onMuteToggle ? (
        <button
          type="button"
          className="p-0.5 rounded hover:bg-white/20 transition-colors"
          title={muted ? 'Unmute' : 'Mute'}
          data-testid={testId ? `${testId}-mute` : undefined}
          onClick={(e) => {
            e.stopPropagation();
            onMuteToggle();
          }}
        >
          {muted
            ? <VolumeX className="w-2.5 h-2.5" style={{ color: accent }} />
            : <Volume2 className="w-2.5 h-2.5 opacity-70" style={{ color: accent }} />}
        </button>
      ) : null}
      <Slider
        orientation="vertical"
        value={[pct]}
        min={0}
        max={100}
        step={1}
        className="h-16 w-5"
        data-testid={testId ? `${testId}-slider` : undefined}
        onValueChange={([v]) => {
          const vol = Math.min(1, Math.max(0, v / 100));
          onVolumeChange?.(vol);
        }}
      />
      <span
        className="text-[8px] font-medium tabular-nums leading-none"
        style={{ color: accent, opacity: 0.85 }}
      >
        {pct}
      </span>
    </div>
  );
}
